import React from 'react'
import styled from 'styled-components'

import SimpleA from '../display/SimpleAnchor'
import SimpleLink from '../display/SimpleLink'

const Message = styled.p`
  text-align: center;
  margin: auto;
  font-weight: 400;
  line-height: 1.5;
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xxs']?.['font-size']?.value};

  color: ${({ theme }) => theme?.['-ds-core-100']?.value};
  ${SimpleA}, ${SimpleLink} {
    color: ${({ theme }) => theme?.['-ds-core-100']?.value};
  }
`

const Outer = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 12px 24px;

  background-color: ${({ theme }) => theme?.['-ds-core-300']?.value};
`

const Banner: React.FC = ({ children }) => (
  <Outer>
    <Message>{children}</Message>
  </Outer>
)

export default Banner
